// Common JS - loaded on all pages
import handleMobileMenu from './mobileMenu';
import handleStickyHeader from './stickyHeader';
import handleBodyClasses from './handleBodyClasses';
import objectFitPolyfill from './objectFitPolyfill';
import initMailchimpValidate from "./initMailChimp";
import handleQuantity from "./handleQuantity";

export default {
  /**
   * Runs first before any JS
   */
  init: () => {
    handleBodyClasses();
    handleStickyHeader();
    handleMobileMenu();
    initMailchimpValidate();
    handleQuantity();
    console.log('Common Init JS Loaded');
  },
  complete: () => {
    objectFitPolyfill();
    console.log('Common Complete JS Loaded');
  },
};
